(() => {
  // A felugró méretválasztó szkriptje (bk-size-drawer.js) csak az első gyorskosár-kattintáskor töltődik be – addig egyik oldalon sem kell.
  // Az útvonalat a theme.liquid adja (data-bk-drawer-src), hogy a gyorsítótár-verzió (?v=) is helyes legyen.
  const drawerSrc = document.currentScript && document.currentScript.dataset.bkDrawerSrc;
  let drawerLoad = null;
  const loadDrawer = () => {
    if (customElements.get('bk-size-drawer')) return Promise.resolve();
    if (!drawerLoad) drawerLoad = new Promise((resolve, reject) => {
      if (!drawerSrc) { reject(new Error('quick-buy-script')); return; }
      const script = document.createElement('script');
      script.src = drawerSrc;
      script.onload = () => customElements.whenDefined('bk-size-drawer').then(resolve);
      // Hálózati hiba: a következő kattintás újrapróbálja
      script.onerror = () => { script.remove(); drawerLoad = null; reject(new Error('quick-buy-script')); };
      document.head.append(script);
    });
    return drawerLoad;
  };
  const quickCart = {
    abort: new AbortController(),
    async open(button) {
      if (this.busy || button.getAttribute('aria-busy') === 'true') return;
      this.busy = true;
      const errorNode = button.closest('[data-bk-card]').querySelector('[data-bk-quick-error]');
      errorNode.hidden = true; button.setAttribute('aria-busy','true');
      try {
        const drawerReady = loadDrawer(); // a szkript és a méretek párhuzamosan töltődnek
        drawerReady.catch(() => {});
        const url = new URL(button.dataset.bkUrl,location.origin); url.searchParams.set('section_id','bk-quick-buy');
        const response = await fetch(url,{signal:this.abort.signal});
        if (!response.ok) throw new Error('quick-buy');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const source = doc.querySelector('.shopify-section');
        if (!source?.querySelector('bk-size-drawer')) throw new Error('quick-buy-markup');
        await drawerReady;
        this.quickSource?.remove();
        for (const node of source.querySelectorAll('script:not([type="application/json"]),noscript')) node.remove();
        this.quickSource = document.importNode(source,true);
        document.body.append(this.quickSource);
        const picker = this.quickSource.querySelector('bk-size-drawer');
        if (!picker.ready) await new Promise((resolve, reject) => {
          const finish = error => {
            clearTimeout(timer);
            picker.removeEventListener('bk:picker-ready', ready);
            picker.removeEventListener('bk:picker-error', failed);
            error ? reject(error) : resolve();
          };
          const ready = () => finish();
          const failed = () => finish(new Error('quick-buy-not-ready'));
          const timer = setTimeout(failed, 12500);
          picker.addEventListener('bk:picker-ready', ready, { once: true });
          picker.addEventListener('bk:picker-error', failed, { once: true });
        });
        picker.quickTrigger = button; picker.open();
      } catch (error) {
        if (error.name !== 'AbortError') { this.quickSource?.remove(); errorNode.hidden = false; }
      } finally { this.busy = false; button.removeAttribute('aria-busy'); }
    }
  };
  // Rubik Combined Listings: ha a kártyán színváltozat-sáv van, a termékoldal előre lefoglalja a helyét (lásd product-info.liquid)
  document.addEventListener('pointerdown', event => {
    const card = event.target.closest('[data-bk-card]');
    if (!card || !card.querySelector('[class*="rcl-"]')) return;
    try { sessionStorage.setItem('bk-rcl:' + card.getAttribute('handle'), '1'); } catch (error) {}
  }, { passive: true, capture: true });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bk-quick-add]');
    if (button) quickCart.open(button);
  });
  const cardNear = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) { cardNear.unobserve(entry.target); entry.target.bkHydrate?.(); }
  }, { rootMargin: '300px 0px' }) : null;
  if (!customElements.get('bk-card-gallery')) customElements.define('bk-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const track = this.querySelector('[data-bk-card-track]');
      if (!track) return;
      const options = {signal: this.abort.signal};
      const buttons = [...this.querySelectorAll('[data-bk-photo-step]')];
      // A további fotók csak első interakcióra épülnek fel (a HTML-ben csak az első kép van)
      const hydrate = () => {
        if (this.hydrated || !this.dataset.bkMore) return;
        this.hydrated = true;
        let list = [];
        try { list = JSON.parse(this.dataset.bkMore); } catch (error) { return; }
        const first = track.querySelector('.bk-card-slide');
        const firstImage = first?.querySelector('img');
        if (!firstImage) return;
        const total = list.length + 1;
        const title = (first.getAttribute('aria-label') || '').replace(/ – \d+ \/ \d+$/, '');
        const fragment = document.createDocumentFragment();
        list.forEach((item, index) => {
          const slide = first.cloneNode(true), image = slide.querySelector('img');
          const src = width => { const url = new URL(item.u, location.href); url.searchParams.set('width', width); return url.href; };
          image.removeAttribute('fetchpriority');
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = src(720);
          image.srcset = [180, 260, 360, 540, 720].map(width => `${src(width)} ${width}w`).join(', ');
          image.width = 720;
          if (item.h) image.height = item.h;
          image.alt = item.a || '';
          slide.setAttribute('aria-label', `${title} – ${index + 2} / ${total}`);
          fragment.append(slide);
        });
        track.append(fragment);
      };
      // Érintőképernyőn NEM érintésre építjük fel a további képeket: ha a koppintás pillanatában változik a tartalom,
      // az iOS Safari az első koppintást „hover”-nek veszi, és csak a másodikra nyitja meg a terméket.
      // Helyette akkor töltjük be, amikor a kártya a képernyő közelébe ér; egérnél továbbra is hoverre.
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hydrate(); }, options);
      this.addEventListener('focusin', hydrate, options);
      this.bkHydrate = hydrate;
      if (this.dataset.bkMore && cardNear && matchMedia('(hover: none)').matches) cardNear.observe(this);
      const move = direction => {
        hydrate();
        const index = Math.round(track.scrollLeft / track.clientWidth);
        const next = Math.max(0, Math.min(track.children.length - 1, index + direction));
        track.scrollTo({left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      for (const button of buttons) button.addEventListener('click', () => move(Number(button.dataset.bkPhotoStep)), options);
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      track.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          for (const button of buttons) button.disabled = Number(button.dataset.bkPhotoStep) < 0 ? index === 0 : index === track.children.length - 1;
        });
      }, {...options, passive:true});
      this.querySelector('[data-bk-photo-step="-1"]')?.setAttribute('disabled', '');
      let startX = 0, startY = 0, dragged = false;
      track.addEventListener('pointerdown', event => { startX = event.clientX; startY = event.clientY; dragged = false; }, options);
      track.addEventListener('pointermove', event => { if (event.buttons && Math.abs(event.clientX - startX) > 8 && Math.abs(event.clientX - startX) > Math.abs(event.clientY - startY)) dragged = true; }, options);
      track.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); } }, {...options, capture:true});
    }
    disconnectedCallback() { this.abort?.abort(); cardNear?.unobserve(this); cancelAnimationFrame(this.scrollFrame); this.scrollFrame = 0; }
  });
  if (customElements.get('bk-collection-controls')) return;
  customElements.define('bk-collection-controls', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.section = this.closest('.shopify-section');
      this.strings = JSON.parse(this.querySelector('[data-bk-collection-strings]').textContent);
      this.params = new URLSearchParams(location.search);
      this.stock = this.params.get('bk_stock') === '1';
      this.sort = this.params.get('sort_by') || this.querySelector('[name="sort_by"]').value;
      this.querySelector('[data-bk-stock]').checked = this.stock;
      const options = {signal:this.abort.signal};
      this.syncPriceRange();
      for (const input of this.querySelectorAll('.bk-filter-price input[type="number"]')) {
        input.addEventListener('input', () => this.syncPriceRange(), options);
      }
      for (const opener of this.querySelectorAll('[data-bk-filter-open]')) opener.addEventListener('click', () => {
        const dialog = this.querySelector(`[data-bk-dialog="${opener.dataset.bkFilterOpen}"]`);
        if (dialog.open) return;
        this.opener = opener; this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded','true'); dialog.showModal();
      }, options);
      for (const dialog of this.querySelectorAll('dialog')) {
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.previousOverflow = undefined;
          this.opener?.setAttribute('aria-expanded','false'); this.opener?.focus();
          if (dialog.dataset.bkDialog === 'filters') { this.querySelector('[data-bk-filter-form]').reset(); this.querySelector('[data-bk-stock]').checked = this.stock; this.syncPriceRange(); }
          else this.querySelector('[data-bk-sort-form]').reset();
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.querySelector('[data-bk-filter-close]').addEventListener('click', () => dialog.close(), options);
      }
      this.querySelector('[data-bk-filter-reset]').addEventListener('click', () => {
        for (const input of this.querySelectorAll('[data-bk-filter-form] input')) {
          if (input.type === 'checkbox') input.checked = false;
          if (input.type === 'number') input.value = '';
        }
        this.syncPriceRange();
      }, options);
      for (const form of this.querySelectorAll('form')) form.addEventListener('submit', event => {
        event.preventDefault();
        const next = form.hasAttribute('data-bk-sort-form') ? new URLSearchParams(location.search) : new URLSearchParams();
        next.delete('page'); next.delete('section_id');
        const data = new FormData(form);
        if (form.hasAttribute('data-bk-sort-form')) next.set('sort_by', data.get('sort_by'));
        else for (const [key,value] of data) if (String(value).trim()) next.append(key,String(value));
        const target = new URL(form.action); target.search = next.toString();
        location.assign(target);
      }, options);
      if (this.stock) {
        const count = this.querySelector('[data-bk-filter-count]'); count.hidden = false; count.textContent = Number(count.textContent) + 1;
        const chip = document.createElement('a'); chip.className = 'bk-filter-chip';
        const target = new URL(location.href); target.searchParams.delete('bk_stock'); target.searchParams.delete('page'); chip.href = target.href; chip.textContent = `${this.strings.stock} ×`;
        this.querySelector('[data-bk-chips]').prepend(chip);
        const clear = this.querySelector('[data-bk-clear]'); clear.hidden = false;
        for (const link of this.querySelectorAll('.bk-filter-chip[href]')) {
          if (link === chip) continue;
          const url = new URL(link.href); url.searchParams.set('bk_stock','1'); url.searchParams.delete('page'); link.href = url.href;
        }
      }
      window.addEventListener('popstate', () => location.reload(), options);
      if (this.stock || (Number(this.dataset.sizeCount) > 0 && this.sort.startsWith('price-'))) this.aggregate();
    }
    syncPriceRange() {
      for (const range of this.querySelectorAll('.bk-filter-price price-range')) {
        const sliders = [...range.querySelectorAll('input[type="range"]')];
        const fields = [...range.querySelectorAll('input[type="number"]')];
        if (sliders.length !== 2 || fields.length !== 2) continue;
        const max = Number(sliders[1].max);
        fields.forEach(field => { field.min = '0'; field.max = String(max); field.step = '1'; });
        sliders.forEach((slider, index) => {
          slider.step = '1';
          slider.value = fields[index].value || (index ? String(max) : '0');
          slider.parentElement.style.setProperty(index ? '--range-max' : '--range-min', `${max > 0 ? Number(slider.value) / max * 100 : 0}%`);
        });
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
    }
    status(message) { const node = this.querySelector('[data-bk-status]'); node.hidden = !message; node.textContent = message; return node; }
    async aggregate() {
      const list = this.section.querySelector('product-list');
      if (!list) return;
      const results = this.section.querySelector('.collection__results');
      results.setAttribute('aria-busy','true'); results.classList.add('bk-collection-loading');
      this.status(this.strings.loading);
      try {
        let cards;
        try { cards = await this.loadIndex(); }
        catch (error) { if (error.name === 'AbortError') throw error; cards = await this.loadPages(list); }
        if (!this.isConnected) return;
        const seen = new Set();
        this.cards = cards.filter(card => {
          const id = card.dataset.bkProductId;
          if (seen.has(id)) return false;
          seen.add(id);
          return Number(card.dataset.bkMatchCount) > 0 && (!this.stock || card.getAttribute('in-stock') === 'true');
        });
        if (this.stock) for (const card of this.cards) {
          card.dataset.bkPrice = card.dataset.bkStockPrice;
          const price = card.querySelector('[data-bk-card-price]');
          price.replaceChildren(card.querySelector('[data-bk-stock-price-template]').content.cloneNode(true));
          for (const link of card.querySelectorAll('[data-bk-product-link]')) link.href = card.dataset.bkStockUrl;
          card.querySelector('[data-bk-quick-add]').dataset.bkUrl = card.dataset.bkStockUrl;
          card.querySelector('[data-bk-card-saving]')?.remove();
          const saving = card.querySelector('[data-bk-stock-saving]').content.textContent.trim();
          if (saving) { const badge = document.createElement('span'); badge.className = 'bk-card-saving'; badge.dataset.bkCardSaving = ''; badge.textContent = saving; card.querySelector('[data-bk-card-price-meta]').append(badge); }
        }
        if (this.sort.startsWith('price-')) this.cards.sort((a,b) => (Number(a.dataset.bkPrice) - Number(b.dataset.bkPrice)) * (this.sort === 'price-descending' ? -1 : 1));
        // Filtering preserves the original page order; no second sort is needed.
        this.querySelector('[data-bk-results-count]').textContent = this.strings.count.replace('{{ count }}',this.cards.length);
        this.section.querySelector('.collection__pagination')?.setAttribute('hidden','');
        this.pagination = document.createElement('nav'); this.pagination.className = 'bk-client-pagination';
        this.pagination.setAttribute('aria-label', this.strings.previous + ' / ' + this.strings.next);
        results.after(this.pagination);
        this.page = Math.max(1,Math.min(Number(this.params.get('page')) || 1,Math.ceil(this.cards.length / Number(this.dataset.perPage)) || 1));
        this.showPage(false);
      } catch (error) {
        if (error.name === 'AbortError') return;
        const node = this.status(this.strings.error), retry = document.createElement('button');
        retry.type = 'button'; retry.textContent = this.strings.retry; retry.addEventListener('click',() => this.aggregate(),{once:true}); node.append(retry);
      } finally { results.removeAttribute('aria-busy'); results.classList.remove('bk-collection-loading'); }
    }
    // Párhuzamos letöltés legfeljebb `limit` kéréssel egyszerre
    async pool(pages, limit, load) {
      const results = new Map(); let cursor = 0;
      const worker = async () => { while (cursor < pages.length) { const page = pages[cursor++]; results.set(page, await load(page)); } };
      await Promise.all(Array.from({length:Math.min(limit, pages.length)}, worker));
      return results;
    }
    // Gyors út: a bk-collection-index szekció 250 terméket ad oldalanként, így ~4 kérés kell a régi 16 helyett
    async loadIndex() {
      const fetchPage = async page => {
        const url = new URL(location.href);
        url.searchParams.set('section_id','bk-collection-index'); url.searchParams.set('page',page);
        const response = await fetch(url,{signal:this.abort.signal});
        if (!response.ok) throw new Error('collection-index');
        const root = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-bk-index]');
        if (!root) throw new Error('collection-index-markup');
        return {pages: Math.max(1, Number(root.dataset.pages) || 1), cards: [...root.querySelectorAll('[data-bk-card]')]};
      };
      const first = await fetchPage(1);
      const rest = await this.pool(Array.from({length:first.pages - 1}, (_,i) => i + 2), 3, fetchPage);
      return [first, ...[...rest.entries()].sort((a,b) => a[0]-b[0]).map(entry => entry[1])].flatMap(page => page.cards);
    }
    // Tartalék: a gyűjtemény összes normál oldalának letöltése
    async loadPages(list) {
      const pages = Number(this.dataset.pages), current = Number(this.dataset.page);
      const pending = Array.from({length:pages}, (_,i) => i+1).filter(page => page !== current);
      const pageMap = await this.pool(pending, 3, async page => {
        const url = new URL(location.href);
        url.searchParams.set('section_id',this.dataset.section); url.searchParams.set('page',page);
        const response = await fetch(url,{signal:this.abort.signal});
        if (!response.ok) throw new Error('collection-page');
        const pageCards = new DOMParser().parseFromString(await response.text(),'text/html').querySelectorAll('[data-bk-card]');
        if (!pageCards.length) throw new Error('collection-empty-page');
        return [...pageCards];
      });
      pageMap.set(current,[...list.querySelectorAll('[data-bk-card]')]);
      return [...pageMap.entries()].sort((a,b) => a[0]-b[0]).flatMap(entry => entry[1]);
    }
    showPage(scroll) {
      const list = this.section.querySelector('product-list'), perPage = Number(this.dataset.perPage), pages = Math.ceil(this.cards.length / perPage);
      list.replaceChildren(...this.cards.slice((this.page-1)*perPage,this.page*perPage));
      this.status(this.cards.length ? '' : this.strings.empty);
      this.pagination.replaceChildren();
      if (pages > 1) {
        const previous = document.createElement('button'), next = document.createElement('button'), counter = document.createElement('span');
        previous.type = next.type = 'button'; previous.textContent = '‹'; next.textContent = '›';
        previous.setAttribute('aria-label',this.strings.previous); next.setAttribute('aria-label',this.strings.next);
        previous.disabled = this.page <= 1; next.disabled = this.page >= pages; counter.textContent = `${this.page} / ${pages}`;
        for (const [button,direction] of [[previous,-1],[next,1]]) button.addEventListener('click',() => { this.page += direction; const url = new URL(location.href); url.searchParams.set('page',this.page); history.pushState({},'',url); this.showPage(true); });
        this.pagination.append(previous,counter,next);
      }
      if (scroll) this.scrollIntoView({block:'start',behavior:'instant'});
    }

  });
})();
